export default {
    "lang": "法语",
    application: {
        name: 'Système de diffusion d\'informations',
    },
    ajaxTip: {
        success: 'Succès',
        error: 'Échec',
        noAccess: 'Accès refusé à cette ressource',
        notFound: 'La ressource demandée n\'existe pas',
        serverBusy: 'Serveur occupé',
        timeOut: 'Délai d\'attente écoulé',
    },
    menu: {
        home: 'Accueil',
        template: 'Gestion des modèles',
        program: 'Gestion des programmes',
        playplan: 'Plan de lecture',
        device: 'Gestion des appareils',
        "source-material": 'Gestion des matériaux',
        material: 'Matériaux',
        checkManage: 'Gestion des audits',
        setting: 'Paramètres',
        usercenter: "Espace utilisateur",
        adminManage: "Gestion des appareils",
        schedule: "Tâches à faire",
        capitalassets: "Gestion des actifs",
        modifyPassword: "Modifier le mot de passe",
        logout: "Déconnexion",
        "add": "Ajouter",
        "edit": "Modifier",
        "delete": "Supprimer",
        "view": "Voir",
        "menu_1": "Accueil",
        "menu_2": "Gestion des appareils",
        "menu_3": "Modifier (Paramètres avancés - Édition basique - Changer le réseau)",
        "menu_4": "Commandes instantanées",
        "menu_5": "Modifier (Transférer le service)",
        "menu_6": "Stratégie",
        "menu_7": "Paramètres de volume",
        "menu_8": "Paramètres de luminosité",
        "menu_9": "Paramètres de téléchargement",
        "menu_10": "Paramètres de veille",
        "menu_11": "Propriétés de l'appareil",
        "menu_12": "Modifier/Ajouter",
        "menu_13": "Gestion des programmes",
        "menu_14": "Historique des publications",
        "menu_15": "Supprimer (Lot/Individuel)",
        "menu_16": "Programmes en cours de publication",
        "menu_17": "Regroupement",
        "menu_19": "Liste des programmes",
        "menu_20": "Édition de contenu",
        "menu_21": "Copier le programme",
        "menu_23": "Publier le programme",
        "menu_24": "Gestion des matériaux",
        "menu_25": "Téléverser",
        "menu_28": "Publication rapide",
        "menu_29": "Gestion des modèles",
        "menu_30": "Modèles publics",
        "menu_31": "Utiliser maintenant",
        "menu_32": "Mes modèles",
        "menu_33": "Publier dans les modèles publics",
        "menu_35": "Historiques de partage",
        "menu_36": "Gestion des audits",
        "menu_37": "Audit des programmes",
        "menu_38": "Auditer (Approuver/Rejeter)",
        "menu_39": "Audit des matériaux",
        "menu_41": "Historique des audits (Opérateur)",
        "menu_42": "Historique des audits (Auditeur)",
        "menu_43": "Voir le nombre d'approbations",
        "menu_44": "Gestion de l'organisation",
        "menu_45": "Gestion des journaux",
        "menu_46": "Journaux de lecture",
        "menu_47": "Journaux de publication",
        "menu_48": "Journaux d'erreurs",
        "menu_49": "Journaux d'opérations",
        "menu_50": "Journaux de fichiers",
        "menu_51": "Journaux de connexion",
        "menu_52": "Approbation de contenu",
        "menu_53": "Espace de stockage",
        "menu_54": "Structure organisationnelle",
        "menu_55": "Autorisations de rôle",
        "menu_56": "Autorisation",
        "menu_57": "Voir (Autorisations d'autorisation)",
        "menu_58": "Membres de l'organisation",
        "menu_60": "Réinitialiser les mots de passe des utilisateurs subordonnés",
        "menu_61": "Gestion des actifs",
        "menu_62": "Mon solde",
        "menu_63": "Voir (Détails des fonds)",
        "menu_64": "Ma consommation de données",
        "menu_65": "Voir (Détails de la consommation de données)",
        "menu_66": "Acheter de la consommation de données",
        "menu_67": "Ma capacité",
        "menu_68": "Mes appareils",
        "menu_69": "Détails de la commande",
        "menu_70": "Voir (Recharger)",
        "menu_71": "Voir (Modèles achetés)",
        "menu_72": "Voir (Consommation de données achetée)",
        "menu_73": "Autres autorisations",
        "menu_74": "Voir (Statistiques des matériaux et programmes)",
        "menu_75": "Voir (Actifs)",
        "menu_76": "Voir (Consommation de données cloud/Statistiques)",
        "menu_77": "Voir (Statistiques des appareils en ligne)"
    },
    login: {
        terminalServiceSystem: 'Système de service terminal intelligent',
        accountLogin: 'Connexion au compte',
        register: 'Inscription',
        accountLoginTip: 'Connexion avec un compte existant',
        scanQRCode: 'Veuillez scanner le code QR',
        readAndAgree: 'J\'ai lu et accepté',
        readAndAgreeLink: 'Conditions d\'utilisation',
        readAndAgreeAgreement: 'Veuillez lire et accepter les conditions d\'utilisation',
        forgetpassword: "Mot de passe oublié ?",
        resetpassword: "Réinitialiser le mot de passe",
        phoneEmptyTip: "Veuillez saisir le numéro de téléphone",
        nextStep: "Étape suivante",
        title: 'Bienvenue à la connexion',
        submit: 'Se connecter',
        userName: 'Compte',
        password: 'Mot de passe',
        userNameEmptyTip: 'Veuillez saisir le compte',
        passwordEmptyTip: 'Veuillez saisir le mot de passe',
        passwordFormatTip: 'Veuillez saisir un format de mot de passe valide',
        passwordIsOk: 'Veuillez confirmer le mot de passe',
        passwordSign: 'Veuillez saisir le mot de passe',
        codeTip: "Veuillez saisir le code de vérification",
        phone: "Le numéro de téléphone ne peut pas être vide",
        code: "Le code de vérification ne peut pas être vide",
        nickname: "Le nom de l'entreprise ne peut pas être vide",
        pass: "Le mot de passe ne peut pas être vide",
        pwdMessage: "Le mot de passe doit comporter 8 à 20 caractères, sans espaces, et inclure au moins 3 des types suivants : lettres majuscules, lettres minuscules, chiffres, caractères spéciaux",
        pwdMessage01: "Veuillez saisir un mot de passe composé de lettres et de chiffres, d'au moins huit caractères",
        pwdMessage02: "Le mot de passe doit comporter 8 à 20 caractères",
        pwdMessage03: "Le mot de passe ne peut pas contenir d'espaces",
        pwdMessage04: "Le mot de passe doit inclure trois des éléments suivants : lettres majuscules, lettres minuscules, chiffres, symboles",
        newpassempty: "Le nouveau mot de passe ne peut pas être vide",
        newpass: "Les deux mots de passe ne correspondent pas",
        getcode: "Obtenir le code de vérification",
        format: "Format de numéro de téléphone invalide",
        chongfa: "Réenvoyer dans secondes",
        isSend: 'Envoyé',
        noregister: "Pas de compte ? Inscrivez-vous immédiatement",
        Mobile: "Numéro de téléphone",
        verificationcode: "Code de vérification",
        petname: "Surnom",
        Quickregistration: "Inscription rapide",
        xiugaimima: "Modifier le mot de passe",
        jiumima: "Ancien mot de passe",
        xinmima: "Nouveau mot de passe",
        zaicishuruxinmima: "Ressaisir le nouveau mot de passe",
        xiugaichenggong: "Modification réussie",
        xiugaishoujihao: "Modifier le numéro de téléphone",
        dengluzhanghao: "Compte de connexion",
        gongsiid: "ID de l'entreprise",
        yonghunicheng: "Surnom de l'utilisateur",
        chuangjianshijian: "Date de création",
        gongsimingcheng: "Nom de l'entreprise",
        denglumima: "Mot de passe de connexion",
        jianyi: "Il est recommandé d'utiliser un mot de passe composé de lettres et de chiffres",
        shezhimima: "Définir le mot de passe",
        shezhishoujihao: "Modifier/Définir le numéro de téléphone",
        yibangding: "Lié",
        weibangding: "Non lié",
        zhanghuanquan: "Sécurité du compte",
        yonghuxinxi: "Informations utilisateur",
        zhuceSucMsg: 'Félicitations, inscription réussie !',
        verificationcodeSucMsg: "Code de vérification envoyé avec succès !",
        requiredIsEmpty: "Les champs obligatoires ne peuvent pas être vides !",
        emailObj: {
            title: 'Email',
            tit: 'Connexion par email',
            tip: 'Veuillez saisir l\'adresse email',
            formatTip: 'Veuillez saisir une adresse email valide',
        },
        phoneObj: {
            title: 'Numéro de téléphone',
            tit: 'Connexion par téléphone',
            tip: 'Veuillez saisir le numéro de téléphone',
            formatTip: 'Veuillez saisir un numéro de téléphone valide',
        },
        emailOrPhoneObj: {
            title: 'Email ou numéro de téléphone',
            tit: 'Connexion par email ou téléphone',
            tip: 'Veuillez saisir l\'email ou le numéro de téléphone',
            formatTip: 'Veuillez saisir un email ou un numéro de téléphone valide',
        },
        wechatObj: {
            title: 'WeChat',
            tit: 'Connexion WeChat',
        },
        googleObj: {
            title: 'Google',
            tit: 'Connexion Google',
        },
        confirm: 'Confirmer',
        confirmSubmit: 'Soumettre la confirmation',
        cancel: 'Annuler',
        close: 'Fermer',
        bindSucMsg: 'Liaison réussie',
        toContinueBindAccount: 'Continuer pour terminer la liaison du compte tiers',
        bindTip01: 'Pas de compte ? Enregistrez-en un',
        bindTip02: 'Compte existant',
        bindTip03: 'Le compte tiers actuel n\'est pas lié à un compte plateforme. Veuillez lier un compte existant ou inscrire et lier un nouveau compte pour une connexion rapide la prochaine fois.',
        bindTip04: 'Lier un compte existant',
        bindTip05: 'Inscrire et lier un nouveau compte',
        bindTip06: 'Vous avez été autorisé par un tiers, complétez les informations de connexion ci-dessous pour terminer la liaison',
        bindSubmit: 'Soumettre la liaison',
        enterAccountTip: 'Veuillez saisir le nom du compte',
        RegisterAndBind: 'Inscrire et lier',
        loginErr: 'Nom d\'utilisateur ou mot de passe incorrect !',
        usercenter: "Espace utilisateur",
        pleaseInputName: "Veuillez saisir le nom",
        operationSuccess: "Opération réussie !",
        edit: "Modifier",
        xiugai: "Modifier",
        userData: "Profil personnel",
        changePassword: "Modification du mot de passe",
        account: "Compte",
        userName01: "Nom d'utilisateur",
        phoneNumber: "Numéro de téléphone",
        role: "Rôle",
        createTime: "Date de création",
        genghuang: "Changer",
        bangding: "Lier",
        unbind: "Dissocier",
        plesaseSelectBindingType: "Veuillez sélectionner le type de liaison",
        pleaseConfirmCont: "Veuillez confirmer que j'ai lu ce contenu",
        confirmReadCont: "J'ai lu ce contenu",
        frequentTip: "Opération trop fréquente, veuillez réessayer plus tard !",
        zhuxiaoBtn: "Supprimer le compte",
        zhuxiaoTitle: "Suppression du compte",
        querenZhuxiao: "Confirmer la suppression",
        jiXu: "Continuer",
        sendCodeBtn: "Envoyer le code de vérification",
        passwordIsNotOldPassword: "Le mot de passe de confirmation est différent du nouveau mot de passe saisi",
        passwordIsOldPassword: "Le nouveau mot de passe est identique à l'ancien",
        passFormatError: "Veuillez saisir un format de mot de passe valide",
        oldPassWord: "Ancien mot de passe",
        newPassWord: "Nouveau mot de passe",
        inputPlaceholder: 'Veuillez saisir',
        confirmPassword: "Confirmer le mot de passe",
        zhuxiaoTip: `
            1、La suppression du compte est irréversible. Une fois le compte supprimé, vous ne pourrez plus vous connecter ni utiliser ce compte ou les comptes tiers enregistrés via ce compte. Veuillez sauvegarder vos informations et données liées au compte.
            2、Avant de supprimer ce compte, veuillez vous assurer que tous les actifs ont été vidés et qu'il n'existe aucun litige ; une fois le compte supprimé, vous renoncez à la propriété de tous les actifs et droits dans ce compte, qui ne pourront pas être récupérés.
            3、Si le nombre total de suppressions de comptes enregistrés avec le même numéro de téléphone atteint 3, ce numéro ne pourra plus être utilisé pour inscrire de nouveaux comptes ni lié à d'autres comptes.
            `
    },
    home: {
        title: "Accueil",
        quickOperation: "Opérations rapides",
        addDevice: "Ajouter un appareil",
        publishProgram: "Publier un programme",
        publishMaterial: "Publier des matériaux",
        makeProgram: "Créer un programme",
        uploadMaterial: "Téléverser des matériaux",
        todayData: "Données du jour (mis à jour toutes les heures)",
        playNumChart: "Statistiques du nombre de lectures",
        deviceOnlineStatus: "État de connectivité des appareils",
        onLineDevice: "Appareils en ligne",
        unLineDevice: "Appareils hors ligne",
        programPlayTime: "Statistiques de la durée de lecture des programmes",
        downloadSoft: "Téléchargement de logiciels",
        adminApp: "Application mobile admin",
        playerApp: "Terminal de lecture de diffusion d'informations",
        downloadAdminApp: "Cliquez pour télécharger l'application admin",
        downloadPlayerApp: "Cliquez pour télécharger l'application de lecture",
        aboutUs: "À propos de nous",
        userManual: "Manuel utilisateur",
        message: "Laisser un message",
    },
    device: {
        inputPlaceholder: 'Veuillez saisir',
        selectPlaceholder: 'Veuillez sélectionner',
        osTypeStr: 'Système terminal',
        onLineStatus: 'État en ligne',
        dpi: 'Résolution',
        companyDeptIdName: 'Organisme affilié',
        deviceGroupIdName: 'Groupe affilié',
        editOrMove: 'Modifier/Déplacer',
        loanOriginationFee: 'Frais de dossier de prêt',
        strategyInfoLook: 'Voir les informations de stratégie',
        programLook: 'Voir les programmes',
        addEquipments: 'Ajouter des appareils',
        luminanceSet: 'Contrôle de luminosité',
        terminal: 'Paramètres du terminal',
        transferCompany: 'Transférer de département',
        releasedProgram: 'Publier un programme',
        screenshot: 'Capture d\'écran',
        changeGroup: 'Changer de groupe',
        defaultGroup: "Groupe par défaut",
        operation: "Opérations",
        edit: "Modifier",
        saveEdit: "Enregistrer les modifications",
        add: "Ajouter",
        save: "Enregistrer",
        setting: "Paramètres",
        program: "Programme",
        unbind: "Dissocier",
        sleep: "Veille",
        wakeup: "Réveiller",
        restart: "Redémarrer",
        shutdown: "Éteindre",
        reportLog: "Rapporter les journaux",
        clearPlayData: "Effacer les données du terminal de lecture",
        offlineWarn: "Cet appareil est hors ligne, veuillez réessayer une fois qu'il est en ligne !",
        confirmUnbind: "Confirmer la dissociation",
        confirmReset: "Confirmer la suppression",
        confirmDelete: "Confirmer la suppression",
        delete: "Supprimer",
        cancelDelete: "Annuler la suppression",
        confirmResetSuccess: "Suppression réussie",
        confirm: "Confirmer",
        cancel: "Annuler",
        operationSuccess: "Opération réussie",
        unbindSuccess: "Dissociation réussie",
        pleaseSelectDevice: "Veuillez sélectionner un appareil",
        pleaseSelectOnlineDevice: "Veuillez sélectionner un appareil en ligne",
        confirmMixOperation: "Les appareils sélectionnés incluent des appareils hors ligne, ce paramètre ne s'appliquera pas aux appareils hors ligne. Confirmer la poursuite de l'opération ?",
        pleaseSelectDate: "Veuillez sélectionner une date",
        reportSuccess: "Rapport réussi",
        deviceSetting: "Paramètres de l'appareil",
        default: "Par défaut",
        all: "Tous",
        deviceList: "Liste des appareils",
        addDevice: "Ajouter un appareil",
        department: "Organisme de département",
        deviceType: "Résolution",
        osType: "Système terminal",
        onlineState: "État en ligne",
        online: "En ligne",
        offline: "Hors ligne",
        notActive: "Non activé",
        search: "Veuillez saisir un mot-clé",
        batchOperation: "Opérations par lot",
        allDevices: "Tous les appareils",
        deviceAttribute: "Attributs de l'appareil",
        selectReportDate: "Sélectionner la date de rapport",
        inputName: "Veuillez saisir le nom",
        inputWidth: "Veuillez saisir la largeur",
        inputHeight: "Veuillez saisir la hauteur",
        inputResolutionRatio: "Veuillez saisir un entier supérieur à 0 !",
        inputSort: "Veuillez saisir le tri",
        serialNum: "Numéro de série",
        name: "Nom",
        width: "Largeur",
        height: "Hauteur",
        resolutionRatio: "Résolution",
        inputResolutionRatioName: "Veuillez saisir le nom de la résolution",
        sort: "Tri",
        personal: "Personnel",
        system: "Système",
        type: "Type",
        systemDefaultSettingUneditable: "Les paramètres par défaut du système ne peuvent pas être modifiés !",
        systemDefaultSettingUnDeletable: "Les paramètres par défaut du système ne peuvent pas être supprimés !",
        newz: "Nouveau",
        total: "Total",
        totalNum: "entrées",
        strategyName: "Nom de la stratégie",
        associatedTerminalNum: "Nombre de terminaux associés",
        createTime: "Date de création",
        pleaseSelectStrategy: "Veuillez sélectionner une stratégie !",
        onlySelectOneData: "Vous ne pouvez sélectionner qu'une seule donnée !",
        downloadStrategy: "Télécharger la stratégie",
        inputStrategyName: "Veuillez saisir le nom de la stratégie",
        luminanceControl: "Contrôle de luminosité",
        volumeStrategy: "Stratégie de volume",
        saveSuccess: "Enregistrement réussi",
        screenAngle: "Rotation de l'écran (°)",
        startTime: "Heure de début",
        endTime: "Heure de fin",
        repeat: "Répéter",
        monday: "Lundi",
        tuesday: "Mardi",
        wednesday: "Mercredi",
        thursday: "Jeudi",
        friday: "Vendredi",
        saturday: "Samedi",
        sunday: "Dimanche",
        everyday: "Chaque jour",
        downloadSpeed: "Vitesse de téléchargement",
        inputDownloadSpeed: "Veuillez saisir la vitesse de téléchargement",
        operator: "Opérations",
        pleaseSelectDeleteData: "Veuillez sélectionner les données à supprimer !",
        confirmBatchDelete: "Confirmer la suppression par lot ?",
        pleaseInputName: "Veuillez saisir le nom",
        detailSetting: "Paramètres détaillés",
        weekPlan: "Plan hebdomadaire",
        specialDateSetting: "Paramètres de dates spéciales",
        weekdayInfo: "Le jour de la semaine est obligatoire !",
        volumeInfo: "Le volume est obligatoire !",
        timeError: "Erreur de sélection d'heure !",
        editSuccess: "Modification réussie !",
        addSuccess: "Ajout réussi !",
        addSpecialPlan: "Ajouter un plan de stratégie spécial",
        downloadSpeedInfo: "Vitesse de téléchargement : (0 signifie interdire le téléchargement)",
        pleaseSelectStartTime: "Veuillez sélectionner l'heure de début",
        pleaseSelectEndTime: "Veuillez sélectionner l'heure de fin",
        luminanceError: "Veuillez saisir une valeur de luminosité valide !",
        defaultLuminance: "Luminosité par défaut",
        luminance: "Niveau de luminosité",
        defaultLuminanceInfo: "Luminosité par défaut (100 = maximum, 0 = minimum)",
        volume: "Volume",
        saveLuminance: "Enregistrer la luminosité",
        changeSuccess: "Modification réussie !",
        changeNetwork: "Changer de réseau",
        netName: "Nom du réseau",
        nameempty: "Le nom du réseau ne peut pas être vide",
        currentNetwork: "Réseau actuel",
        ipAddress: "Adresse IP",
        dailyMode: "Mode quotidien",
        weeklyMode: "Mode hebdomadaire",
        turnOnTime: "Heure de mise sous tension",
        turnOffTime: "Heure d'extinction",
        startSleep: "Début de la veille",
        endSleep: "Fin de la veille",
        batchDelInfo: "Confirmer la suppression des éléments sélectionnés ?",
        timeCannotBeEmpty: "L'heure ne peut pas être vide !",
        startUp: "Mise sous tension",
        shutDown: "Extinction",
        volumeSize: "Niveau de volume",
        defaultVolume: "Volume par défaut (100 = maximum, 0 = muet)",
        chooseStartTime: "Veuillez sélectionner l'heure de début",
        chooseEndTime: "Veuillez sélectionner l'heure de fin",
        saveVolume: "Enregistrer le volume",
        screenRotationUnSaved: "Rotation de l'écran non enregistrée",
        volumeSettingUnSaved: "Paramètres de volume non enregistrés",
        luminanceSettingUnSaved: "Paramètres de luminosité non enregistrés",
        confirmClosePopup: "Confirmer la fermeture de cette fenêtre pop-up ?",
        volumeSettingSuccess: "Modification du volume réussie",
        luminanceSettingSuccess: "Modification de la luminosité réussie",
        advancedSettingUnSaved: "Paramètres avancés non enregistrés",
        settingTitle: "Paramètres du terminal",
        volumeSetting: "Paramètres de volume",
        luminanceSetting: "Paramètres de luminosité",
        downloadSetting: "Paramètres de téléchargement",
        sleepSetting: "Paramètres de veille",
        onOffSetting: "Mise sous tension/extinction programmée",
        screenRotation: "Rotation de l'écran",
        namingError: "Erreur de nommage, le nom de fichier ne peut pas contenir d'espaces !",
        deleteSuccess: "Suppression réussie",
        deleteFolder: "Supprimer le dossier",
        pleaseInputDeviceName: "Veuillez saisir le nom de l'appareil",
        pleaseInputDeviceId: "Veuillez saisir l'ID de l'appareil",
        discoverDevice: "Découvrir un appareil",
        deviceId: "ID de l'appareil",
        bound: "Lié",
        bind: "Lier",
        noDevice: "Aucun appareil",
        refresh: "Actualiser",
        manualAdd: "Ajout manuel",
        deviceGroup: "Classification des appareils",
        pleaseSelectGroup: "Veuillez sélectionner un groupe !",
        deviceName: "Nom de l'appareil",
        goAdd: "Aller à l'ajout",
        close: "Fermer",
        bindCountInsufficient: "Nombre de liaisons disponibles insuffisant, veuillez augmenter le nombre d'appareils avant d'ajouter !",
        displayNumber: "Numéro d'affichage",
        groupName: "Nom du groupe",
        pleaseSelectGroupName: "Veuillez saisir le nom du groupe !",
        moveGroup: "Déplacer le groupe",
        longitude: "Longitude",
        latitude: "Latitude",
        nationality: "Nationalité",
        province: "Province",
        city: "Ville",
        county: "District",
        outNetIp: "IP externe",
        inNetIp: "IP interne",
        companyName: "Nom de l'entreprise",
        Info: "Détails",
        android: "Android",
        win: "Windows",
        osVersion: "Version du système",
        softwareVersion: "Version du logiciel",
        diskSize: "Taille du disque",
        useSize: "Espace utilisé",
        macAddr: "Adresse MAC",
        longitudeLatitudeInfo: "La longitude et la latitude doivent être vides ou renseignées simultanément !",
        terminalName: "Nom du terminal",
        terminalGroup: "Groupe de terminaux",
        reportJournal: "Rapport activé",
        systemVersion: "Version du système",
        storageSpace: "Espace de stockage",
        resolution: "Résolution",
        runningMemory: "Mémoire vive",
        model: "Modèle",
        registerStatus: "État d'enregistrement",
        password: "Mot de passe",
        passwordInfo: "Veuillez saisir 6 à 18 lettres ou chiffres !",
        group: "Groupe",
        address: "Adresse",
        remark: "Remarques",
        renewalPeriod: "Période de renouvellement",
        money: "Frais",
        latitudeInfo: "Veuillez saisir une latitude valide !",
        totalPayment: "Montant total",
        longitudeInfo: "Veuillez saisir une longitude valide !",
        setMeal: "Forfait",
        number: "Quantité",
        programName: "Nom du programme",
        playStatus: "État de lecture",
        playType: "Mode de lecture",
        play: "Lire",
        pause: "Pause",
        playTime: "Heure de lecture",
        programDeleted: "Programme supprimé",
        playSuccess: "Programme programmé pour lecture",
        pauseSuccess: "Pause réussie",
        playCycle: "Lecture en boucle",
        playInsert: "Lecture insérée",
        withdrawSuccess: "Retrait réussi",
        withdrawInfo: "Veuillez d'abord sélectionner le programme à retirer !",
        programBelong: "Programme affilié",
        checkAll: "Tout sélectionner",
        batchDel: "Suppression par lot",
        delConfirm: "Confirmer la suppression des éléments sélectionnés ?",
        check: "Sélectionné",
        noProgram: "Aucun programme",
        details: "Détails",
        screenshotFail: "Échec de la capture d'écran",
        policyName: "Nom de la politique",
        terminalNum: "Nombre de terminaux associés",
        powerStrategy: "Stratégie d'alimentation",
        pleaseSelectDepartment: "Veuillez sélectionner un département !",
        screenshotControl: "Contrôle de capture d'écran",
        未激活: "Non activé",
        已激活: "Activé",
        未绑定: "Non lié",
        已绑定: "Lié",
    },
    programManage: {
        programList: "Liste des programmes",
        publishProgram: "Suivi de publication des programmes",
        week1: "Lundi",
        week2: "Mardi",
        week3: "Mercredi",
        week4: "Jeudi",
        week5: "Vendredi",
        week6: "Samedi",
        week7: "Dimanche",
        monday: "Lundi",
        tuesday: "Mardi",
        wednesday: "Mercredi",
        thursday: "Jeudi",
        friday: "Vendredi",
        saturday: "Samedi",
        sunday: "Dimanche",
        name: "Nom",
        preview: "Aperçu",
        playDeviceNum: "Nombre d'appareils de lecture",
        copyDeviceCode: "Cliquez pour copier",
        osType: "Type de système",
        playDate: "Date de lecture",
        playWeek: "Semaine de lecture",
        everyday: "Chaque jour",
        start: "Début",
        end: "Fin",
        playOperateStatusStr: "État de publication",
        playDevice: "Appareil de lecture",
        downloadView: "Voir les téléchargements",
        publisher: "Éditeur",
        publishTime: "Heure de publication",
        operation: "Opérations",
        add: "Ajouter",
        groupName: "Nom du groupe",
        selectDevice: "Sélectionner le terminal",
        searchDevice: "Rechercher le terminal",
        pleaseFillGroupName: "Veuillez saisir le nom du groupe !",
        remarkInfo: "Remarques",
        compile: "Modifier",
        withdrawConfirm: "Confirmer le retrait de ce programme ?",
        confirm: "Confirmer",
        cancel: "Annuler",
        withdraw: "Retirer",
        batchWithdraw: "Retrait par lot",
        batchPublish: "Publication par lot",
        batchDelete: "Suppression par lot",
        batchOperation: "Opérations par lot",
        notUse: "Non utilisé",
        notChecked: "Non vérifié",
        notPass: "Non approuvé",
        delete: "Supprimer",
        publishTextLeft: "Publié",
        offTextLeft: "Suspendu",
        pleaseSelectProgramToMove: "Veuillez sélectionner le programme à transférer !",
        pause: "Pause",
        pauseConfirm: "Confirmer la pause ?",
        play: "Lire",
        downloadUdisk: "Télécharger sur clé USB",
        deviceList: "Liste des appareils",
        groupSelection: "Sélection de groupe",
        operationSuccess: "Opération réussie",
        deleteSuccess: "Suppression réussie",
        selectDate: "Sélectionner une date",
        publishStatus: "État de publication",
        checkStatus: "État de vérification",
        waitAuditing: "En attente de vérification",
        auditPass: "Vérification approuvée",
        auditRefuse: "Vérification refusée",
        all: "Tous",
        playStatus: "En lecture",
        playStatust: "État de lecture",
        pauseStatus: "Suspendu",
        notStartStatus: "Non commencé",
        resolutionratio: "Résolution",
        totalNum: "entrées",
        programName: "Nom du programme",
        playStartTime: "Heure de début de lecture",
        playEndTime: "Heure de fin de lecture",
        createTime: "Date de création",
        nationality: "Nationalité",
        province: "Province",
        city: "Ville",
        county: "District",
        address: "Adresse",
        ip: "Adresse IP",
        location: "Emplacement",
        log: "Journaux",
        pleaseFillProgramName: "Veuillez saisir le nom du programme !",
        selectGroup: "Sélectionner un groupe",
        startTime: "Heure de début",
        endTime: "Heure de fin",
        publishCycle: "Cycle de publication",
        publishDeviceNum: "Nombre d'appareils de publication",
        pleaseSelectRecord: "Veuillez sélectionner un enregistrement",
        deviceName: "Nom du terminal",
        deviceId: "ID du terminal",
        deviceGroupIdName: "Groupe d'appartenance",
        notClassified: "Non classé",
        osTypeStr: "Système terminal",
        storageSpace: "Espace de stockage",
        onLineStatus: "État en ligne",
        onLine: "En ligne",
        offLine: "Hors ligne",
        sleep: "Veille",
        unknown: "Inconnu",
        registerStatus: "État d'enregistrement",
        trialPeriod: "Période d'essai",
        notActive: "Non activé",
        active: "Activé",
        parameterError: "Paramètres incorrects !",
        pleaseSelectProgram: "Veuillez sélectionner un programme !",
        pleaseSelectProgramEdit: "Veuillez sélectionner le programme à modifier !",
        confirmWithdrawSelectedProgram: "Confirmer le retrait des programmes sélectionnés ?",
        withdrawSuccess: "Retrait réussi",
        allPrograms: "Tous les programmes",
        defaultGroup: "Groupe par défaut",
        cannotShareEmptyProgram: "Impossible de partager un programme vide !",
        onlyShareYourProgram: "Vous ne pouvez partager que les programmes que vous avez créés !",
        pleaseSelectProgramEditPublishTime: "Veuillez sélectionner le programme dont l'heure de publication a été modifiée !",
        pleaseSelectDevice: "Veuillez sélectionner un appareil !",
        programDetail: "Détails du programme",
        errorReason: "Cause de l'erreur",
        availableStorageSpaceInsufficient: "Espace de stockage disponible insuffisant",
        partialDeviceReleaseFailure: "Publication échouée sur certains appareils",
        allDeviceReleaseSuccess: "Publication réussie sur tous les appareils",
        partialDeviceReleaseSuccess: "Publication réussie sur certains appareils",
        allGroup: "Tous les groupes",
        allProgram: "Tous les programmes",
        unGrouped: "Non groupé",
        replaceProgram: "Remplacer le programme",
        replaceProgramTip: "Le nouveau programme publié remplacera les données des programmes précédemment envoyés sur le terminal de lecture !",
        screen: "Écran simple/double",
        singleScreen: "Écran simple",
        doubleScreen: "Écran double",
        playSetting: "Paramètres de lecture",
        batchPlaySetting: "Définir l'heure de lecture par lot",
        individualPlaySetting: "Définir l'heure de lecture individuellement",
        playTime: "Heure de lecture",
        daily: "Chaque jour",
        weekdays: "Du lundi au vendredi",
        monthly: "Ce mois-ci",
        advancedSetting: "Paramètres avancés",
        playProgram: "Lire le programme",
        searchProgram: "Veuillez saisir un mot-clé",
        shareAddressNotExist: "L'adresse de lien n'existe pas, veuillez réessayer",
        copySuccess: "Copie réussie",
        shareLink: "Lien de partage",
        publish: "Publier",
        noResource: "Aucune ressource",
        single: "Écran simple",
        double: "Écran double",
        time: "Heure",
        associatedTerminalNum: "Nombre de terminaux associés",
        default: "Par défaut",
        moveGroup: "Déplacer le groupe",
        pleaseSelectGroup: "Veuillez saisir le nom du groupe !",
        copy: "Copier",
        FUBEN: "Copie",
        nameempty: "Le nom ne peut pas être vide",
        whitespace: "Erreur de nommage, le nom de fichier ne peut pas contenir d'espaces !",
        programWhitespace: "Erreur de nommage, le nom du programme ne peut pas contenir d'espaces !",
        pleaseSelectResolution: "Veuillez sélectionner une résolution !",
        dataError: "Données incorrectes !",
        createProgram: "Créer un nouveau programme",
        directCreate: "Création directe",
        myTemplate: "Mes modèles",
        use: "Utiliser",
        free: "Gratuit",
        loadMore: "Charger plus",
        confirmDelete: "Confirmer la suppression",
        deleteGroup: "Supprimer le groupe",
        notPublished: "Non publié",
        notPassed: "Non approuvé",
        notUsed: "Non utilisé",
        confirmDeleteSelectedProgram: "Confirmer la suppression des programmes sélectionnés ?",
        companyName: "Nom de l'entreprise",
        programCannotDownload: "Ce programme ne peut pas être téléchargé !",
        publishMaterial: "Publier des matériaux",
        playMaterial: "Lire des matériaux",
        pleaseInputMaterialName: "Veuillez saisir le nom du matériau",
        size: "Taille",
        pleaseInputDeviceName: "Veuillez saisir le nom de l'appareil",
        item: "entrées",
        allMaterial: "Tous les matériaux",
        allDevices: "Tous les appareils",
        "saveSuccess": "Enregistré avec succès",
        "savefaill": "Échec de l'enregistrement",
        "playMode": "Mode de lecture",
        "cyclePlay": "Lecture en boucle",
        "insertPlay": "Lecture insérée",
        "noData": "Aucune donnée",
        "Add": "Ajouter",
        "replace": "Remplacer",
        "repeat": "Répéter",
        "start01": "Démarrer",
        "end01": "Terminer",
        "startDate": "Date de début",
        "endDate": "Date de fin",
        "useNow": "Utiliser immédiatement",
        "fillStartEndTimeFirst": "Veuillez remplir l'heure de début et de fin avant d'ajouter",
        "fillFullPlayTime": "Veuillez remplir la durée de lecture complète",
        "fillCorrectPlayTime": "Veuillez remplir la période de lecture correcte",
        "sDateAndEDateBothEmptyOrFilled": "La date de début et la date de fin doivent être toutes les deux vides ou toutes les deux remplies"
    },
    source: {
        addResource: "Ajouter une ressource",
        width: "Largeur",
        height: "Hauteur",
        size: "Taille (KB)",
        name: "Nom",
        pleaseInputResourceName: "Veuillez saisir le nom de la ressource !",
        addToGroup: "Ajouter au groupe",
        remark: "Remarques",
        promptFgIllustrate: "Illustration",
        promptFgRealisticPhoto: "Photo réaliste",
        promptFgSimplisticDrawing: "Dessin simple",
        promptFgChineseStyle: "Style chinois",
        promptFgPixelArt: "Pixel art",
        noModel: "Aucun modèle disponible, veuillez contacter l'administrateur !",
        getModelFailed: "Échec de récupération du modèle, veuillez réessayer plus tard ! Ou contactez l'administrateur !",
        createImagePrompt: "Génération de l'image en cours, veuillez fermer plus tard !",
        promptEmpty: "Veuillez saisir le prompt",
        dpiEmpty: "Veuillez sélectionner le ratio de l'image !",
        fgEmpty: "Veuillez sélectionner le style !",
        style: "Style",
        idEmpty: "L'ID de l'image ne peut pas être vide",
        exist: "Cette image existe déjà dans les matériaux",
        addSuccess: "Ajout du matériau réussi",
        saveError: "Échec de sauvegarde de l'image, veuillez réessayer plus tard !",
        delSuccess: "Suppression réussie",
        generateImage: "Texte en image",
        generateImagePlaceholder: 'Veuillez saisir l\'image que vous souhaitez générer, par exemple : un papillon dansant au milieu d\'un champ de fleurs',
        aiExpand: "Extension intelligente AI",
        negativePrompt: "Prompt négatif",
        negativePromptTooltip: "Utilisé pour exclure explicitement le contenu ou les caractéristiques que l'utilisateur ne souhaite pas voir dans la sortie",
        imageRatio: "Ratio de l'image",
        generateImageBtn: "Générer immédiatement",
        shengchengjieguo: "Résultat de génération",
        generateImageLoadingTip: "Génération en cours, ne cliquez pas plusieurs fois ni fermez...",
        Tooltip: "Venez donner vie à votre créativité avec l'AI",
        saveToMaterial: "Sauvegarder dans les matériaux",
        publish: "Publier immédiatement",
        download: "Télécharger",
        generateHistory: "Historique des générations",
        hide: "Réduire",
        cancel: "Annuler",
        useExpand: "Utiliser l'extension",
        all: "Tous",
        delete: "Supprimer",
        loadMore: "Charger plus",
        aiTip: "Le contenu est généré par un modèle d'intelligence artificielle et ne reflète pas les opinions, positions ou attitudes de la plateforme. Veuillez utiliser le contenu AI de manière légale et conforme.",
        operationSuccess: "Opération réussie",
        moveGroup: "Déplacer le groupe",
        groupName: "Nom du groupe",
        pleaseSelectGroup: "Veuillez sélectionner le nom du groupe !",
        shenhe: "Vérification",
        shenheStatus: "État de vérification",
        shenheSuccess: "Vérification approuvée",
        shenheRefuse: "Vérification refusée",
        pleaseSelectShenheStatus: "Veuillez sélectionner l'état de vérification !",
        shenheRemark: "Remarques de vérification",
        pleaseInputShenheRemark: "Veuillez saisir les remarques de vérification !",
        pleaseInputFileName: "Veuillez saisir le nom de fichier !",
        whitespace: "Erreur de nommage, le nom de fichier ne peut pas contenir d'espaces !",
        dataError: "Données incorrectes !",
        confirmDelete: "Confirmer la suppression",
        confirm: "Confirmer",
        deleteFolder: "Supprimer le dossier",
        add: "Ajouter",
        edit: "Modifier",
        fileName: "Nom de fichier",
        group: "Groupe",
        resolution: "Résolution",
        type: "Type",
        image: "Image",
        music: "Musique",
        video: "Vidéo",
        uploadTime: "Heure de téléversement",
        uploadUser: "Téléverseur",
        checkTime: "Heure de vérification",
        checkUser: "Vérificateur",
    },
    setting: {
        nameempty: "Le nom ne peut pas être vide",
        heightempty: "La hauteur ne peut pas être vide",
        widthempty: "La largeur ne peut pas être vide",
        resolutionratio: "Résolution",
        name: "Nom",
        opteration: "Opérations",
        compile: "Modifier",
        delete: "Supprimer",
        newz: "Nouveau",
        compileratio: "Modifier la résolution",
        sheizhifenbianlvmingcheng: "Définir le nom de la résolution",
        shezhigaodu: "Définir la hauteur",
        shezhikuandu: "Définir la largeur",
        xinzengfenbianlv: "Ajouter une résolution",
        bianma: "Code",
        bianjizhongduanmingcheng: "Modifier le nom du terminal",
        xinzengzhongduan: "Ajouter un terminal",
        selectPrimaryColor: 'Sélectionner la couleur du thème',
        fullScreen: 'Plein écran',
        exitFullScreen: 'Quitter le plein écran',
    },
    tabs: {
        refresh: 'Actualiser',
        refreshAll: 'Actualiser tout',
        close: 'Fermer',
        closeOthers: 'Fermer les autres',
        closeAll: 'Fermer tout',
        closeLeft: 'Fermer la gauche',
        closeRight: 'Fermer la droite',
    },
    errorPage: {
        needLogin: 'Vous n\'êtes pas connecté !',
        pageNotFound: 'La page que vous recherchez n\'existe pas !',
        redirectTo: 'Rediriger vers',
        orReturn: 'Ou retourner à',
        previousStep: 'Étape précédente',
    },
    headerUs: {
        systemNotice: "Notification système",
        allNotices: "Toutes les notifications",
        viewAllMessages: "Voir tous les messages",
        contactUs: "Nous contacter",
        operationSuccess: "Opération réussie !",
        leaveMessage: "Laisser un message",
        messageTitle: "Titre",
        messageTitleTip: "Veuillez saisir le titre !",
        messageContentTip: "150 caractères maximum",
        submit: "Soumettre",
        markAsRead: "Marquer comme lu",
        success: "Opération réussie !"
    },
    material: {
        allMaterial: "Tous les matériaux",
        defaultGroup: "Groupe par défaut",
        auditStatus: "État de vérification",
        auditPassed: "Vérification approuvée",
        auditRejected: "Vérification refusée",
        pendingAudit: "En attente de vérification",
        all: "Tous",
        operateSuccess: "Opération réussie !",
        pleaseSelectMaterial: "Veuillez sélectionner des matériaux !",
        moveGroup: "Déplacer vers le groupe",
        pleaseSelectGroup: "Veuillez sélectionner un groupe !",
        batchPublish: "Publier par lot",
        batchRecall: "Rappeler par lot",
        batchDelete: "Supprimer par lot",
        materialList: "Liste des matériaux",
        uploadMaterial: "Téléverser des matériaux",
        materialType: "Type de matériau",
        pleaseInputMaterialName: "Veuillez saisir le nom du matériau",
        selectAll: "Tout sélectionner",
        confirmDeleteSelectedMaterial: "Confirmer la suppression des matériaux sélectionnés ?",
        deleteSuccess: "Suppression réussie",
        delete: "Supprimer",
        publish: "Publier",
        recall: "Rappeler",
        confirmRecallSelectedMaterial: "Confirmer le rappel des matériaux sélectionnés ?",
        pleaseSelectMaterialGroup: "Veuillez sélectionner le groupe de matériaux !",
        recallSuccess: "Rappel réussi",
        publishSuccess: "Publication réussie",
        batchOperate: "Opérations par lot",
        item: "entrées",
        confirmDelete: "Confirmer la suppression ?",
        edit: "Modifier",
        confirmRecall: "Confirmer le rappel ?",
        unaudited: "Non vérifié",
        notPassed: "Non approuvé",
        operate: "Opérations",
        resolution: "Résolution",
        none: "Aucun",
        confirm: 'Confirmer',
        cancel: 'Annuler',
        AICreation: "Création IA",
    },
    uploadFile: {
        operationSuccess: "Opération réussie",
        uploadFile: "Gestion des téléversements",
        uploadSuccess: "Téléversement réussi",
        uploadCompleted: "Téléversement terminé",
        uploadFail: "Échec du téléversement",
        ConversionFailed: "Échec de la conversion !",
        loading: "Chargement en cours...",
        beQueuing: "En file d'attente...",
        Uploading: "Téléversement en cours...",
        ConversionIng: "Conversion en cours...",
        ConventionalResources: "Ressources classiques",
        DocumentResources: "Ressources documentaires",
        complete: "Terminé",
        upload: "Téléverser",
        fileSizeWraning01: "La taille du matériau dépasse",
        fileSizeWraning02: "Veuillez modifier et téléverser à nouveau !",
        fileIsEmpty: "Le fichier est vide",
        uploadFileTip: "Format de fichier non pris en charge",
        unablePreview: "Non ajouté avec succès à la bibliothèque de matériaux, prévisualisation impossible",
        confirmDelete: "Confirmer la suppression ?",
        deleteSuccess: "Suppression réussie",
        delete: "Supprimer",
        confirm: "Confirmer",
        preview: "Prévisualiser",
        close: "Fermer",
        cancel: "Annuler",
        fileType: "Type de fichier",
        fileSize: "Taille du fichier",
        conversionProgress: "Progression de la conversion",
        progress: "Progression",
        image: "Image",
        video: "Vidéo",
        audio: "Audio",
        limitTip01: "Téléversement d'un maximum de",
        limitTip02: "fichiers à la fois",
        okTip: "Téléversement des matériaux en cours, veuillez ne pas fermer la fenêtre !",
        usableSize: 'Espace disponible',
        sizeUnableTip: "Espace de stockage disponible insuffisant. Veuillez nettoyer les matériaux inutilisés pour libérer de l'espace ou contacter votre distributeur pour étendre la capacité de stockage cloud. Des frais peuvent être applicables, veuillez vous référer aux informations du distributeur.",
        view: "Voir les détails",
        fileName: "Nom du fichier",
    },
    template: {
        inputPlaceholder: 'Veuillez saisir',
        selectPlaceholder: 'Veuillez sélectionner',
        noAuths: "Aucune autorisation, veuillez contacter l'administrateur",
        operationSuccess: "Opération réussie",
        total: "Total",
        totalNum: "entrées",
        dan: "Simple",
        shaung: "Double",
        pleaseSelectGroup: "Veuillez sélectionner un groupe",
        preview: "Prévisualiser",
        free: "Gratuit",
        use: "Utiliser",
        dpi: 'Résolution',
        delete: "Supprimer",
        confirmDelete: "Confirmer la suppression",
        confirmDeleteSelectedTemplate: "Confirmer la suppression de ce modèle ?",
        push: "Publier",
        pushConfirm: "Confirmer la publication dans les modèles publics ?",
        pushRemovalConfirm: "Confirmer le retrait des modèles publics ?",
        templateOrderRecord: "Historique des commandes de modèles",
        unpublished: "Non publié",
        auditing: "En cours de vérification",
        publishRejected: "Publication refusée",
        publishSuccess: "Publication réussie",
        offShelf: "Retirer du marché",
        公共模版: "Modèles publics",
        我的模板: "Mes modèles",
        共享记录: "Historique des partages",
        name: "Nom",
        pubdate: "Date de publication",
        keySeachTip: "Veuillez saisir un mot-clé",
        allGroup: "Tous les groupes",
        add: "Ajouter",
        edit: "Modifier",
        programName: "Nom du programme",
        selectGroup: "Sélectionner un groupe",
    },
    checkManage: {
        total: "Total",
        totalNum: "entrées",
        operationSuccess: "Opération réussie",
        checkUserLogs: "Historique des vérifications (opérateur)",
        checkLogs: "Historique des vérifications (vérificateur)",
        sourceCheck: "Vérification des matériaux",
        programCheck: "Vérification des programmes",
        checkAll: "Tout sélectionner",
        auditPass: "Vérification approuvée",
        auditRefuse: "Vérification refusée",
        auditPass01: "Approuvé",
        auditRefuse01: "Refusé",
        auditRefuse02: "Refuser la vérification",
        auditor: "Vérificateur",
        agentUserName: "Éditeur",
        interrogationTime: "Heure de soumission pour vérification",
        checkTime: "Heure de vérification",
        checkName: "Nom de l'élément vérifié",
        checkType: "Catégorie de vérification",
        checkIp: "Adresse IP de soumission",
        checkReason: "Message",
        checkStatus: "Contenu de l'opération",
        rangePicker: "Date de vérification",
        keyWord: "Mot-clé",
        all: "Tous",
        program: 'Programme',
        material: 'Matériau',
        dan: "Simple",
        shaung: "Double",
        pleaseSelectProgram: "Veuillez sélectionner un programme !",
        pleaseSelectMaterial: "Veuillez sélectionner des matériaux !",
        preview: "Prévisualiser",
        dpi: 'Résolution',
        auditRefuseTip: "Veuillez saisir la raison du refus",
        unreviewed: "Non vérifié",
        notPassed: "Non approuvé",
        notUsed: "Non utilisé",
        edit: "Modifier",
        none: "Aucun",
        name: "Nom",
        size: "Taille",
        type: "Type",
        uploadTime: "Heure de téléversement",
        uploadUser: "Téléverseur",
        checkUser: "Vérificateur",
        image: "Image",
        music: "Musique",
        video: "Vidéo",
    },
    systemSet: {
        total: "Total",
        totalNum: "entrées",
        inputPlaceholder: 'Veuillez saisir',
        selectPlaceholder: 'Veuillez sélectionner',
        userList: "Membres de l'organisation",
        roleList: "Autorisations des rôles",
        department: "Structure organisationnelle",
        diskInfo: "Espace de stockage",
        approveSet: "Approbation du contenu",
        logList: "Gestion des journaux",
        name: "Nom",
        account: "Compte",
        userName: "Nom de l'utilisateur",
        phoneNumber: "Numéro de téléphone",
        role: "Rôle",
        createTime: "Date de création",
        operation: "Opérations",
        edit: "Modifier",
        delete: "Supprimer",
        addNew: "Nouveau",
        add: "Ajouter",
        resetPassword: "Réinitialiser le mot de passe",
        confirmDelete: "Confirmer la suppression",
        departmentOrganization: "Organisme de département",
        addNewUser: "Ajouter un nouvel utilisateur",
        pleaseEnterUserName: "Veuillez saisir le nom de l'utilisateur",
        confirmPasswordNotMatch: "Le mot de passe de confirmation ne correspond pas au mot de passe saisi !",
        operationSuccess: "Opération réussie !",
        userNickname: "Nom d'affichage de l'utilisateur",
        pleaseEnterUserNickname: "Veuillez saisir le nom d'affichage de l'utilisateur",
        userNicknameRequired: "Le nom d'affichage de l'utilisateur ne peut pas être vide !",
        password: "Mot de passe",
        pleaseEnterPassword: "Veuillez saisir le mot de passe",
        passwordRequired: "Le mot de passe ne peut pas être vide !",
        passwordTip: "La sécurité de votre mot de passe est trop faible (il doit contenir au moins 3 des types suivants : lettres majuscules, lettres minuscules, chiffres, caractères spéciaux, et avoir une longueur de 8 caractères minimum)",
        confirmPassword: "Confirmer le mot de passe",
        pleaseEnterPhoneNumber: "Veuillez saisir le numéro de téléphone",
        phoneNumberRequired: "Le numéro de téléphone ne peut pas être vide !",
        phoneNumberFormatError: "Veuillez saisir un numéro de téléphone valide !",
        roleRequired: "Le rôle ne peut pas être vide !",
        required: "Ne peut pas être vide !",
        departmentName: "Département",
        modifyPassword: "Modifier le mot de passe",
        newPassword: "Nouveau mot de passe",
        pleaseEnterNewPassword: "Veuillez saisir le nouveau mot de passe",
        pwdMessage: "Le mot de passe doit comporter 8 à 20 caractères, sans espaces, et inclure au moins 3 des types suivants : lettres majuscules, lettres minuscules, chiffres, caractères spéciaux",
        all: "Tous",
        noAuths: "Aucune autorisation, veuillez contacter l'administrateur",
        departmentName01: "Nom du département",
        image: "Image",
        music: "Musique",
        video: "Vidéo",
        buySize: "Quantité achetée",
        totalMoney: "Montant payé",
        buycreateTime: "Date d'achat",
        endTime: "Date d'expiration",
        buyTypeStr: "Type de commande",
        sourceCheck: "Vérification des matériaux",
        programCheck: "Vérification des programmes",
        programName: "Nom du programme",
        diskExpansion: "Il est recommandé de nettoyer régulièrement les matériaux expirés/inutilisés pendant l'utilisation pour garantir l'espace disponible du système. Si vous avez besoin d'un espace de stockage plus important, vous pouvez contacter votre fournisseur d'appareils pour obtenir un service d'extension de capacité de stockage cloud. Ce service peut générer des frais, veuillez vous référer aux informations de votre distributeur pour plus de détails.",
        selectPermission: "Veuillez sélectionner les autorisations",
        checkPermission: "Veuillez cocher les autorisations",
        addRole: "Ajouter un rôle",
        enterRoleName: "Veuillez saisir le nom du rôle",
        roleName: "Nom du rôle",
        roleNameRequired: "Le nom du rôle ne peut pas être vide !",
        remark: "Remarques",
        enterRemark: "Veuillez saisir des remarques",
        permissionSetting: "Paramètres des autorisations",
        deleteSuccess: "Suppression réussie !",
        confirmToDelete: "Confirmer la suppression ?",
        orgName: "Nom de l'organisme",
        orgNameRequired: "Le nom de l'organisme ne peut pas être vide !",
        orgRemark: "Remarques sur l'organisme",
        enterOrgRemark: "Veuillez saisir des remarques sur l'organisme",
        capacityUsage: "État d'utilisation de la capacité",
        usedCapacity: "Capacité utilisée",
        totalCapacity: "Capacité totale",
        remainingCapacity: "Capacité restante",
        capacityExpansion: "Extension de capacité",
        enable: "Activer",
        disable: "Désactiver",
        userName01: "Nom d'utilisateur",
        loginTime: "Heure de connexion",
        ipAddress: "Adresse IP",
        loginResult: "Résultat de la connexion",
        selectDate: "Sélectionner une date",
        enterDate: "Veuillez sélectionner une date",
        selectStartTime: "Veuillez sélectionner l'heure de début",
        selectEndTime: "Veuillez sélectionner l'heure de fin",
        enterUserName: "Veuillez saisir le nom d'utilisateur",
        userCount: "Nombre d'utilisateurs",
        roleDesc: "Description du rôle",
        roleAuthorization: "Autorisation du rôle",
        success: "Succès",
        failure: "Échec",
        time: "Heure",
        operationContent: "Contenu de l'opération",
        playCount: "Nombre de lectures",
        playDuration: "Durée de lecture",
        selectDevice: "Sélectionner un appareil",
        enterProgramName: "Veuillez saisir le nom du programme",
        serialNumber: "Numéro de série",
        publishContentName: "Nom du contenu publié",
        playMode: "Mode de lecture",
        cyclePlay: "Lecture en boucle",
        insertPlay: "Lecture insérée",
        paddingPlay: "Lecture de secours",
        playDeviceId: "ID de l'appareil de lecture",
        playDeviceName: "Nom de l'appareil de lecture",
        publishTime: "Heure de publication",
        downloadStatus: "État du téléchargement",
        notDownloaded: "Non téléchargé",
        downloading: "Téléchargement en cours",
        downloadSucceeded: "Téléchargement réussi",
        downloadFailed: "Échec du téléchargement",
        enterPublishContentName: "Veuillez saisir le nom du contenu publié",
        terminalId: "ID du terminal",
        belongOrg: "Organisme d'appartenance",
        reportTime: "Heure du rapport",
        reportIp: "IP du rapport",
        logInfo: "Informations du journal",
        details: "Détails",
        confirmDeletion: "Confirmer la suppression ?",
        logDetails: "Détails du journal",
        download: "Télécharger",
        deptOrg: "Organisme de département",
        query: "Rechercher",
        queryByTerminalId: "Rechercher par ID de terminal",
        batchDeleteLogs: "Supprimer les journaux par lot",
        customTimeDeleteLogs: "Supprimer les journaux dans une plage horaire personnalisée",
        selectTimeRangeFirst: "Veuillez d'abord sélectionner une plage horaire",
        deleteAllDeviceLogsIfEmpty: "Si aucun ID d'appareil n'est saisi, tous les journaux des appareils seront supprimés par défaut",
        enterDeviceIdToDeleteLogs: "Veuillez saisir l'ID de l'appareil dont les journaux doivent être supprimés",
        confirmDeleteAction: "Confirmer la suppression",
        selectDeleteRangeFirst: "Veuillez d'abord sélectionner la plage de suppression",
        networkConnectionFailed: "Échec de la connexion réseau",
        playLog: "Journal de lecture",
        publishLog: "Journal de publication",
        errorLog: "Journal d'erreurs",
        operationLog: "Journal d'opérations",
        fileLog: "Journal de fichiers",
        userOperateLog: "Journal de connexions",
    },
    userManual: {
        userManual: "Manuel utilisateur",
        noData: "Aucune donnée disponible",
    },
    systemNotice: {
        systemNotice: "Notification système",
        noData: "Aucune donnée disponible",
        total: "Total",
        totalNum: "entrées",
        "markAllRead": "Tout marquer comme lu",
        "deleteAll": "Supprimer tout",
        "all": "Tous",
        "unread": "Non lu",
        "read": "Lu",
        "type": "Type",
        "content": "Contenu",
        "date": "Date",
        "status": "État",
        "confirmDelete": "Confirmer la suppression ?",
        "confirm": "Confirmer",
        "cancel": "Annuler",
        "delete": "Supprimer"
    }
};